import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import formDialog from "../skin/form-dialog/form-dialog.skin";
import { getTitleTranslation } from "../../../utils/translations-helper";
import Form from "./form";
import { useSelector } from "react-redux";
import classNames from "classnames";
import DialogHeader from "../common/dialog-header";

const useStyles = createUseStyles(formDialog);

const Modal = (props) => {
  const { formModalLoading, formModalClose, formState, formModalOpen } = props;

  const classes = useStyles();
  const subject = useSelector((state) => state.configuration.subject);

  return (
    <div
      className={classNames(classes["dialog"], {
        [classes["dialog-open"]]: formModalOpen,
        [classes["dialog-closed"]]: !formModalOpen,
      })}
      tabIndex="-1"
      role="dialog"
    >
      <div className={classes["modal-dialog"]}>
        <div className={classes["modal-content"]}>
          <DialogHeader
            title={getTitleTranslation(formState, subject)}
            onClose={formModalClose}
          />
          {formModalOpen && (
            <div className="modal-body">
              {formModalLoading ? (
                <div className={classes["skeleton-loader"]} />
              ) : (
                <Form {...props} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  formModalLoading: PropTypes.bool,
  formModalOpen: PropTypes.bool,
  formState: PropTypes.string,
  openInModal: PropTypes.bool,
};

export default Modal;
